// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('appInvoice/getData', async params => {
  const { q = '', perPage = 15, page = 1, pendingOnly = null, sort, sortColumn, startDate, endDate, entityIds, paymentStatus } = params
  const response = await axios.get(`/v1/invoices`, {
    params: { page, perPage, q, excludePaid: pendingOnly, startDate, endDate, sort, sortColumn, entityIds, paymentStatus }
  })

  return {
    params,
    data: response.data.invoices,
    totalPages: response.data.totalPages,
    total: response.data.total,
    totalPendingUsd: response.data.totalPendingUsd || 0,
    totalOverdueUsd: response.data.totalOverdueUsd || 0,
    totalExcessUsd: response.data.totalExcessUsd || 0,
    pendingOnly,
    currentPage: page,
    startDate,
    endDate,
    entityIds
  }
})

export const deleteInvoice = createAsyncThunk('appInvoice/deleteInvoice', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/invoice/delete', { id })
  await dispatch(getData(getState().invoice.params))
  return id
})

export const appInvoiceSlice = createSlice({
  name: 'appInvoice',
  initialState: {
    data: [],
    total: 1,
    totalPendingUsd: 0,
    totalOverdueUsd: 0,
    totalExcessUsd: 0,
    params: {},
    allData: [],
    isLoading: false,
    error: null,
    pendingOnly: true,
    currentPage: 1,
    startDate: null,
    endDate: null,
    entityIds: null
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.pending, (state) => {
      state.isLoading = true
      state.error = null
    })
    // Without this a failed fetch left the page loading forever.
    builder.addCase(getData.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.error?.message || 'Failed to load invoices'
    })
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.total
      state.totalPendingUsd = action.payload.totalPendingUsd
      state.totalOverdueUsd = action.payload.totalOverdueUsd
      state.totalExcessUsd = action.payload.totalExcessUsd
      state.totalPages = action.payload.totalPages
      state.params = action.payload.params
      state.pendingOnly = action.payload.pendingOnly
      state.currentPage = action.payload.currentPage
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
      state.entityIds = action.payload.entityIds
      state.isLoading = false
    })
  }
})

export default appInvoiceSlice.reducer
